import React from "react";

import "./Modal.scss";

interface ModalProps {
  isShowing: boolean;
  hideModal(): void;
  content?: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  if (!props.isShowing) {
    return null;
  }
  return (
    <div className="scc-Modal">
      <div className="scc-ModalScreen" onClick={props.hideModal} />
      <div className="scc-ModalContent">{props.content}</div>
    </div>
  );
};
